import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "4-30",
  "description": "Yoga Sutra Chapter 4, Verse 30"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "-4-30--"
    }}><a parentName="h3" {...{
        "href": "/Chapter-4/4-29/"
      }}>{`<`}</a>{` 4-30 `}{` `}<a parentName="h3" {...{
        "href": "/Chapter-4/4-31/"
      }}>{`>`}</a></h3>
    <h1 {...{
      "id": "tataḥ-kleśa-karma-nivṛttiḥ"
    }}>{`tataḥ kleśa-karma-nivṛttiḥ`}</h1>
    <h3 {...{
      "id": "ततः-क्लेशकर्मनिवृत्तिः"
    }}>{`ततः क्लेशकर्मनिवृत्तिः`}</h3>
    <h4 {...{
      "id": "from-that-cessation-of-afflicted-action"
    }}>{`From that cessation of afflicted action`}</h4>
    <br />
    <p><strong parentName="p">{`tatas`}</strong>{` - hence, from that`}</p>
    <p><strong parentName="p">{`kleśa`}</strong>{` - afflictions; distress; anguish`}</p>
    <p><strong parentName="p">{`karman`}</strong>{` - act, action, performance; work, labour, activity; any religious act or rite; organ of sense`}</p>
    <p><strong parentName="p">{`nivṛtti`}</strong>{` - cessation`}</p>
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      